import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42c5d952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-header navbar navbar-expand navbar-white navbar-light" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      "data-widget": "pushmenu",
      href: "#",
      role: "button"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" })
    ])
  ])
], -1))
const _hoisted_3 = { class: "navbar-nav ml-auto" }
const _hoisted_4 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logout_modal = _resolveComponent("logout-modal")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.showingDialog = true))
        }, "ログアウト")
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.state.showingDialog)
          ? (_openBlock(), _createBlock(_component_logout_modal, {
              key: 0,
              onDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.showingDialog = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}